var AssetDirectory = {
	"load": [
		"assets/.DS_Store",
		"assets/bgm/bgm.ogg",
		"assets/fonts/airbagfree-regular.woff",
		"assets/fonts/londonbetween.woff",
		"assets/htp/htp_am1.png",
		"assets/htp/htp_am2.png",
		"assets/htp/htp_am3.png",
		"assets/htp/htp_am4.png",
		"assets/ingame/am_bg.png",
		"assets/ingame/am_rock_base.png",
		"assets/ingame/box_blue_01.png",
		"assets/ingame/box_blue_02.png",
		"assets/ingame/box_blue_03.png",
		"assets/ingame/box_blue_04.png",
		"assets/ingame/box_blue_05.png",
		"assets/ingame/box_blue_06.png",
		"assets/ingame/box_blue_07.png",
		"assets/ingame/box_blue_08.png",
		"assets/ingame/box_blue_09.png",
		"assets/ingame/box_blue_10.png",
		"assets/ingame/box_green_01.png",
		"assets/ingame/box_green_02.png",
		"assets/ingame/box_green_03.png",
		"assets/ingame/box_green_04.png",
		"assets/ingame/box_green_05.png",
		"assets/ingame/box_green_06.png",
		"assets/ingame/box_green_07.png",
		"assets/ingame/box_green_08.png",
		"assets/ingame/box_green_09.png",
		"assets/ingame/box_green_10.png",
		"assets/ingame/box_orange_01.png",
		"assets/ingame/box_orange_02.png",
		"assets/ingame/box_orange_03.png",
		"assets/ingame/box_orange_04.png",
		"assets/ingame/box_orange_05.png",
		"assets/ingame/box_orange_06.png",
		"assets/ingame/box_orange_07.png",
		"assets/ingame/box_orange_08.png",
		"assets/ingame/box_orange_09.png",
		"assets/ingame/box_orange_10.png",
		"assets/ingame/box_red_01.png",
		"assets/ingame/box_red_02.png",
		"assets/ingame/box_red_03.png",
		"assets/ingame/box_red_04.png",
		"assets/ingame/box_red_05.png",
		"assets/ingame/box_red_06.png",
		"assets/ingame/box_red_07.png",
		"assets/ingame/box_red_08.png",
		"assets/ingame/box_red_09.png",
		"assets/ingame/box_red_10.png",
		"assets/ingame/box_violet_01.png",
		"assets/ingame/box_violet_02.png",
		"assets/ingame/box_violet_03.png",
		"assets/ingame/box_violet_04.png",
		"assets/ingame/box_violet_05.png",
		"assets/ingame/box_violet_06.png",
		"assets/ingame/box_violet_07.png",
		"assets/ingame/box_violet_08.png",
		"assets/ingame/box_violet_09.png",
		"assets/ingame/box_violet_10.png",
		"assets/ingame/box_yellow_01.png",
		"assets/ingame/box_yellow_02.png",
		"assets/ingame/box_yellow_03.png",
		"assets/ingame/box_yellow_04.png",
		"assets/ingame/box_yellow_05.png",
		"assets/ingame/box_yellow_06.png",
		"assets/ingame/box_yellow_07.png",
		"assets/ingame/box_yellow_08.png",
		"assets/ingame/box_yellow_09.png",
		"assets/ingame/box_yellow_10.png",
		"assets/ingame/btn_arrow.png",
		"assets/ingame/cm_ui_matchpopup.png",
		"assets/ingame/cm_ui_shufflebtn.png",
		"assets/ingame/cm_ui_shufflebtn_pressed.png",
		"assets/ingame/fx_cut_sparkle_ske.json",
		"assets/ingame/fx_cut_sparkle_tex.json",
		"assets/ingame/fx_cut_sparkle_tex.png",
		"assets/ingame/fx_glow_green.png",
		"assets/ingame/fx_glow_red.png",
		"assets/ingame/fx_glow_yellow.png",
		"assets/ingame/fx_sparkle.png",
		"assets/ingame/layout_rotation_ske.json",
		"assets/ingame/layout_rotation_tex.json",
		"assets/ingame/layout_rotation_tex.png",
		"assets/ingame/rotation/rotate_cross_01.png",
		"assets/ingame/rotation/rotate_cross_02.png",
		"assets/ingame/rotation/rotate_cross_03.png",
		"assets/ingame/rotation/rotate_cross_04.png",
		"assets/ingame/rotation/rotate_cross_05.png",
		"assets/ingame/rotation/rotate_cross_06.png",
		"assets/ingame/rotation/rotate_cross_07.png",
		"assets/ingame/rotation/rotate_cross_08.png",
		"assets/ingame/rotation/rotate_cube3_01.png",
		"assets/ingame/rotation/rotate_cube3_02.png",
		"assets/ingame/rotation/rotate_cube3_03.png",
		"assets/ingame/rotation/rotate_cube3_04.png",
		"assets/ingame/rotation/rotate_cube4_01.png",
		"assets/ingame/rotation/rotate_cube4_02.png",
		"assets/ingame/rotation/rotate_cube4_03.png",
		"assets/ingame/rotation/rotate_cube4_04.png",
		"assets/ingame/rotation/rotate_heart_01.png",
		"assets/ingame/rotation/rotate_heart_02.png",
		"assets/ingame/rotation/rotate_heart_03.png",
		"assets/ingame/rotation/rotate_heart_04.png",
		"assets/ingame/rotation/rotate_heart_05.png",
		"assets/ingame/rotation/rotate_heart_06.png",
		"assets/ingame/rotation/rotate_heart_07.png",
		"assets/ingame/rotation/rotate_heart_08.png",
		"assets/ingame/rotation/rotate_pyramid_01.png",
		"assets/ingame/rotation/rotate_pyramid_02.png",
		"assets/ingame/rotation/rotate_pyramid_03.png",
		"assets/ingame/rotation/rotate_pyramid_04.png",
		"assets/ingame/rotation/rotate_tablet_01.png",
		"assets/ingame/rotation/rotate_tablet_02.png",
		"assets/ingame/rotation/rotate_tablet_03.png",
		"assets/ingame/rotation/rotate_tablet_04.png",
		"assets/ingame/rotation/rotate_tablet_05.png",
		"assets/ingame/rotation/rotate_tablet_06.png",
		"assets/ingame/rotation/rotate_tablet_07.png",
		"assets/ingame/rotation/rotate_tablet_08.png",
		"assets/sfx/bonus.ogg",
		"assets/sfx/button_sfx.ogg",
		"assets/sfx/correct.ogg",
		"assets/sfx/ding.ogg",
		"assets/sfx/score_points.ogg",
		"assets/sfx/select.ogg",
		"assets/sfx/star_gain.ogg",
		"assets/sfx/tic.ogg",
		"assets/sfx/toc.ogg",
		"assets/sfx/wrong.ogg",
		"assets/titlescreen/am_title.png",
		"assets/titlescreen/am_title_cube_01.png",
		"assets/titlescreen/am_title_cube_02.png",
		"assets/titlescreen/am_title_cube_03.png",
		"assets/titlescreen/am_title_cube_04.png",
		"assets/titlescreen/am_title_glow.png",
		"assets/ui/btn_audio1.png",
		"assets/ui/btn_audio2.png",
		"assets/ui/btn_audio3.png",
		"assets/ui/btn_audio4.png",
		"assets/ui/btn_close.png",
		"assets/ui/btn_exit.png",
		"assets/ui/btn_exit2.png",
		"assets/ui/btn_pause.png",
		"assets/ui/btn_pause2.png",
		"assets/ui/btn_play.png",
		"assets/ui/btn_play2.png",
		"assets/ui/btn_prevnext.png",
		"assets/ui/btn_prevnext2.png",
		"assets/ui/btn_return.png",
		"assets/ui/btn_return2.png",
		"assets/ui/check-button1.png",
		"assets/ui/check-button2.png",
		"assets/ui/gfx_container.png",
		"assets/ui/gfx_container_white.png",
		"assets/ui/gfx_explode.png",
		"assets/ui/gfx_flare_long.png",
		"assets/ui/gfx_flare_star.png",
		"assets/ui/gfx_loading_bar_con.png",
		"assets/ui/gfx_pop.png",
		"assets/ui/gfx_pop2.png",
		"assets/ui/gfx_star0.png",
		"assets/ui/gfx_star1.png",
		"assets/ui/gfx_starbg.png",
		"assets/ui/x-button1.png",
		"assets/ui/x-button2.png"
	],
	"preload": [
		"assets/preload/fonts/Exo-Bold.otf",
		"assets/preload/fonts/Exo-Medium.ttf",
		"assets/preload/fonts/proximanova-black.otf",
		"assets/preload/strings/gizmoloading_ske.json",
		"assets/preload/strings/gizmoloading_tex.json",
		"assets/preload/strings/strings.json",
		"assets/preload/ui/gfx_bg.png",
		"assets/preload/ui/gfx_loading.png",
		"assets/preload/ui/gizmoloading_tex.png"
	],
	"preloadstring": [
		"assets/strings/config.json"
	]
};